export default "__VITE_ASSET__1b9f013b__"